export default [
  {
    action: "manage",
    resource: "all",
    header: "Ajuda",
  },
  {
    action: "manage",
    resource: "all",
    icon: "SmileIcon",
    title: "Vuexy Docs",
    href: "https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/documentation/guide",
  },
  {
    action: "manage",
    resource: "all",
    icon: "BoldIcon",
    title: "BootstrapVue Docs",
    href: "https://bootstrap-vue.org/",
  },
  {
    action: "manage",
    resource: "all",
    icon: "CodeIcon",
    title: "Bootstrap Docs",
    href: "https://getbootstrap.com/docs/5.0/getting-started/introduction/",
  },
];
